import React from 'react';
import Icon from './Icon';

const AlertTriangleIcon = (props) => (
    <Icon {...props}>
        <path
            d="M12 7.5V12M12 16.5H12.01M9.5 2.4A10 10 0 1 1 2.4 9.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default AlertTriangleIcon;
